var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"info-section pb-3"},[_c('i',{staticClass:"fas fa-info-circle"}),_c('span',{staticClass:"info-section-title"},[_vm._v(_vm._s(_vm.title))])]),_c('section',{class:{ 'info-section-margin-left': !_vm.noBodyMargin }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }